import messages from '../messages'

export default function Translate(item) {
  switch (item) {
    case 'role':
      return messages.MSG_ROLE_BLANK
    case 'firstname':
      return messages.MSG_FIRST_NAME_BLANK
    case 'lastname':
      return messages.MSG_LAST_NAME_BLANK
    case 'username':
      return messages.MSG_USERNAME_BLANK
    case 'email':
      return messages.MSG_EMAIL_BLANK
    case 'password':
      return messages.MSG_PASSWORD_BLANK
    case 'confirm_password':
      return messages.MSG_CONFIRM_PASSWORD_BLANK
    case 'pin':
      return messages.MSG_PIN_BLANK
  }
}
